import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ContentfulForm from '../ContentfulForm'
import styled from 'styled-components'
import { rem } from 'polished'

const Wrapper = styled.div`
  .form-modal {
    padding-top: ${rem(20)};
    padding-bottom: ${rem(20)};
  }
`

function FormModal(props: App.ComponentForm) {
  return <Wrapper>
    <ModalHeader
      title={props.title}
      key={props.slug}
    />
    <ModalBody>
      <ContentfulForm className="form-modal" {...props} />
    </ModalBody>
  </Wrapper>
}

export default FormModal
